import { render } from "./Resit.vue?vue&type=template&id=17675009"
import script from "./Resit.vue?vue&type=script&lang=js"
export * from "./Resit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__